import { Button, Tooltip, GlanceLoader } from '../ui-components';
import React from 'react';

function PresenceState({onEnterKey, onMCS, onJoin, gicon, showMCS=true, showEnterKey=true}) {

  return (
    <>
      <div className="SizeWrapper">
        <div className="rowAlign">
          { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
          { showEnterKey && <span className="wrapper">
            <Tooltip text="Instant connect" offset={8} size="small">
            <Button
              className="PresenceLayout"
              size="small"
              variant="warning"
              shape="rounded-full"
              animation={true}
              onClick={() => (typeof(onJoin) === typeof(Function)) ? onJoin() : console.log('Presence pressed')}
            >
              Join
            </Button>
            </Tooltip>
            <Tooltip text="Enter customer’s key" offset={8} size="small">
            <Button
              size="small"
              variant="secondary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onEnterKey) === typeof(Function)) ? onEnterKey() : console.log('Have key pressed')}
            >
              Have key?
            </Button>
            </Tooltip>
          </span> }

          { showMCS && <span className="wrapper">
            <Tooltip text="Send link to customer’s phone" offset={8} size="small"> 
            <Button
              size="small"
              variant="tertiary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onMCS) === typeof(Function)) ? onMCS() : console.log('MCS pressed')}
            >
              Camera Share
            </Button>
            </Tooltip>
          </span> }
        </div>
      </div>
    </>
  );
}

export default PresenceState;
